export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/vb3077c1da4d40c951f5c1b7bdffc6a4f18686b0d-runtime-main.ecd34866.worker.js");
}
